export enum EquipmentDashboardTabEnum {
  InProcess = 1,
  Dispatched = 2,
  ByJob = 3,
  Scorecard = 4,
}
